import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShiftMac = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm7.504 14.293a1 1 0 0 0-.725.305l-5.5 5.709A1 1 0 0 0 13 31h2v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5h2a1 1 0 0 0 .72-1.693l-5.5-5.71a1 1 0 0 0-.716-.304zm-.004 2.441L21.646 29H21a1 1 0 0 0-1 1v5h-3v-5a1 1 0 0 0-1-1h-.646l3.146-3.266z" />
    </svg>
);
export default SvgShiftMac;
